const AirportType = {
  FETCH_AIRPORT_LIST: 'airport/fetch_airport_list',
};

export default AirportType;
